import {Drawer as MaterialDrawer} from "../../../../__snowpack__/pkg/@mui/material.js";
import MaterialBox from "../../../../__snowpack__/pkg/@mui/material/Box.js";
import styled from "styled-components";
export const DrawerContainer = styled(MaterialDrawer).withConfig({
  displayName: "drawerstyles__DrawerContainer",
  componentId: "sc-xb1ssz-0"
})([".MuiPaper-root{@media (min-width:960px){left:270px;}}"]);
export const DrawerWrapper = styled(MaterialBox).withConfig({
  displayName: "drawerstyles__DrawerWrapper",
  componentId: "sc-xb1ssz-1"
})(["", " width:25vw;"], {
  display: "flex",
  flex: "1 1 0%",
  flexDirection: "column",
  justifyContent: "space-between",
  margin: "1.5rem"
});
export const DrawerTitle = styled(MaterialBox).withConfig({
  displayName: "drawerstyles__DrawerTitle",
  componentId: "sc-xb1ssz-2"
})(["", ""], {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: "2.25rem"
});
export const DrawerContent = styled(MaterialBox).withConfig({
  displayName: "drawerstyles__DrawerContent",
  componentId: "sc-xb1ssz-3"
})(["", ""], {
  display: "flex",
  flex: "1 1 0%",
  flexDirection: "column"
});
